export default __webpack_public_path__ + "static/media/pipe_drive_image.edbdde63.png";